import React from 'react';

export const SpecTable = ({ rows, title = 'Specification' }) => (
    <div className="border border-brand-hairline bg-brand-surface" data-testid="spec-table">
        <div className="border-b border-brand-hairline bg-brand-elevated px-6 py-3">
            <span className="font-display text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold">
                {title}
            </span>
        </div>
        <dl>
            {rows.map((r, i) => (
                <div
                    key={r.label}
                    className={[
                        'grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-1 sm:gap-6 px-6 py-4',
                        i !== rows.length - 1 ? 'border-b border-brand-hairline' : '',
                    ].join(' ')}
                >
                    <dt className="font-display text-xs font-bold uppercase tracking-[0.16em] text-brand-muted">
                        {r.label}
                    </dt>
                    <dd className="font-sans text-sm text-brand-text">{r.value}</dd>
                </div>
            ))}
        </dl>
    </div>
);

export default SpecTable;
